import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";
import { ModalPreguntaEnlaceService } from "./modal-pregunta-enlace.service";

@Component({
  selector: "app-modal-pregunta-enlace",
  templateUrl: "./modal-pregunta-enlace.component.html",
  styleUrls: ["./modal-pregunta-enlace.component.scss"],
})
export class ModalPreguntaEnlaceComponent implements OnInit {
  @Input()
  modalGenerico: ModalGenericoModel;
  infoPregunta: any;
  pregunta_id: any;

  preguntasLista: Array<any> = [];
  filtro: Array<any> = [];
  filtroString: string = "";

  constructor(
    private activeModal: NgbActiveModal,
    private modalPreguntaEnlaceService: ModalPreguntaEnlaceService
  ) {}

  ngOnInit() {
    this.modalGenerico = {
      titulo: "",
    };

    this.pregunta_id =
      this.infoPregunta.clase_pregunta_id === 2
        ? this.infoPregunta.pregunta_adicional_encuesta_id
        : this.infoPregunta.pregunta_encuesta_id;

    this.modalPreguntaEnlaceService
      .getObtenerPreguntas(
        {
          pregunta_encuesta_id: this.pregunta_id,
          pregunta_adicional_encuesta_id: this.pregunta_id,
          tipo_pregunta_encuesta_id: this.infoPregunta
            .tipo_pregunta_encuesta_id,
        },
        this.infoPregunta.clase_pregunta_id === 2
      )
      .subscribe((resultado) => {
        if (resultado.data && resultado.data.length > 0) {
          this.preguntasLista = resultado.data.reduce((acc, el) => {
            if (this.infoPregunta.clase_pregunta_id === 2) {
              acc.push({
                id: el.pregunta_adicional_encuesta_id,
                name: el.descripcion,
                value: false,
              });
            } else {
              acc.push({
                id: el.pregunta_encuesta_id,
                name: el.descripcion,
                value: false,
              });
            }

            return acc;
          }, []);

          this.filtro = this.preguntasLista;
        }

        this.modalPreguntaEnlaceService
          .getObtenerPreguntas(
            {
              pregunta_encuesta_id: this.pregunta_id,
              pregunta_adicional_encuesta_id: this.pregunta_id,
              tipo_pregunta_encuesta_id: null,
            },
            this.infoPregunta.clase_pregunta_id === 2
          )
          .subscribe((resultado2) => {
            if (resultado2.data && resultado2.data.length > 0) {
              const enlaces = resultado2.data.reduce((acc, el) => {
                if (this.infoPregunta.clase_pregunta_id === 2) {
                  acc.push({
                    id: el.pregunta_adicional_encuesta_id,
                    name: el.descripcion,
                    value: true,
                  });
                } else {
                  acc.push({
                    id: el.pregunta_encuesta_id,
                    name: el.descripcion,
                    value: true,
                  });
                }

                return acc;
              }, []);

              this.preguntasLista = [...this.preguntasLista, ...enlaces];

              this.filtro = this.preguntasLista;
            }
          });
      });
  }

  seleccionPregunta(id: number) {
    this.preguntasLista = this.preguntasLista.reduce((acc, el) => {
      if (el.id === id) {
        acc.push({
          id: el.id,
          name: el.name,
          value: !el.value,
        });
      } else acc.push(el);
      return acc;
    }, []);
  }

  dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }

  close(): void {
    if (this.activeModal) {
      const lista_preguntas_id: string = this.preguntasLista.reduce(
        (acc, el) => {
          if (el.value) acc += acc.length > 0 ? `, ${el.id}` : `${el.id}`;
          return acc;
        },
        ""
      );
      this.activeModal.close({
        lista_preguntas_id,
        anio: this.infoPregunta.anio,
        pregunta_encuesta_id: this.pregunta_id,
        pregunta_adicional_encuesta_id: this.pregunta_id,
        seccion_encuesta_id: this.infoPregunta.seccion_encuesta_id,
        clase_pregunta_id: this.infoPregunta.clase_pregunta_id,
      });
    }
  }

  filtrar(value: string) {
    this.filtroString = value;

    this.filtro = this.preguntasLista.reduce((acc, el) => {
      const name = el.name.trim().toLowerCase();
      const string = value.trim().toLowerCase();

      if (name.includes(string)) acc.push(el);

      return acc;
    }, []);
  }
}
